<loading-indicator />
<splash-screen />
<router-outlet />
